import { render, staticRenderFns } from "./siderHome.vue?vue&type=template&id=2be481c1&scoped=true"
import script from "./siderHome.vue?vue&type=script&lang=js"
export * from "./siderHome.vue?vue&type=script&lang=js"
import style0 from "./siderHome.vue?vue&type=style&index=0&id=2be481c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be481c1",
  null
  
)

export default component.exports